import React from 'react'
import { Redirect, Link } from 'react-router-dom'
import axios from 'axios';
import DocumentMeta from 'react-document-meta';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'

import AppContext from '../../../AppContext.js';
import OffsetTop from '../../../components/offsetTop.js';

const localization = {
    ua: {
        title: 'Передача техніки',
        new: 'Створення документу',
        edit: 'Редагування документу',

        chooseTruck: 'Оберіть вантажівку',
        chooseTrailer: 'Оберіть причіп',
        chooseDriverFrom: 'Оберіть водія (від кого)',
        chooseDriverTo: 'Оберіть водія (кому)',

        searchText: 'Пошук...',

        truck: 'Номер вантажівки',
        trailer: 'Номер причепа',
        mileage: 'Пробіг',
        fuel: 'Паливо',
        driverFrom: 'Від кого',
        driverTo: 'Кому',

        button: 'Зберегти',

        noData: 'Немає даних',
    },
    ru: {
        title: 'Передача техники',
        new: 'Создание документа',
        edit: 'Редактирование документа',

        chooseTruck: 'Выберите грузовик',
        chooseTrailer: 'Выберите прицеп',
        chooseDriverFrom: 'Выберите водителя (от кого)',
        chooseDriverTo: 'Выберите водителя (кому)',

        searchText: 'Поиск...',
        
        truck: 'Номер грузовика',
        trailer: 'Номер прицепа',
        mileage: 'Пробег',
        fuel: 'Топливо',
        driverFrom: 'От кого',
        driverTo: 'Кому',

        button: 'Сохранить',

        noData: 'Нет данных',
    },
    en: {
        title: 'Transfer of equipment',
        new: 'Сreate document',
        edit: 'Edit document',

        chooseTruck: 'Select a truck',  
        chooseTrailer: 'Select a trailer',
        chooseDriverFrom: 'Select a driver (from whom)',
        chooseDriverTo: 'Select a driver (to whom)',

        searchText: 'Search...',
       
        truck: 'Truck number',
        trailer: 'Trailer number',
        mileage: 'Milage',
        fuel: 'Fuel',
        driverFrom: 'Driver from',
        driverTo: 'Driver to',

        button: 'Save',

        noData: 'No data',
    },
}

class CheckListNew extends React.Component {
    static contextType = AppContext;

    constructor(props) {
        super(props);
		
		this.state = {
            isLoading: true,
            redirect: null,

            trucks: [],
            trailers: [],
            users: [],

            isTruckOpen: false,
            isTrailerOpen: false,
            isDriverFromOpen: false,
            isDriverToOpen: false,

            truckSearch: "",
            trailerSearch: "",
            driverFromSearch: "",
            driverToSearch: "",

            truck: "",
            trailer: "",
            mileage: "",
            fuel: "",
            driverFrom: null,
            driverFromLocked: false,
            driverTo: null,
        }

        this.truckOpen = this.truckOpen.bind(this);
        this.trailerOpen = this.trailerOpen.bind(this);
        this.driverFromOpen = this.driverFromOpen.bind(this);
        this.driverToOpen = this.driverToOpen.bind(this);

        this.onInputChange = this.onInputChange.bind(this);
        this.save = this.save.bind(this);
    }

    componentDidMount() {
        const {lang, setMenuExpandText, token, id, access, addNotification, removeNotification} = this.context;
        setMenuExpandText(localization[lang].title);

        var did = this.props.match.params.did;
        var lock = !access.includes('23001'); // user is driver, lock driver from field to his id

        if (process.env.NODE_ENV === 'production') {
            var u = addNotification("Завантаження...");
            
            if (did == 'new') {
                var usersPromise = axios.post('/api/service/transfer/users', { token: token });
                var trucksPromise = axios.post('/api/service/transfer/trucks', { token: token });
                var trailersPromise = axios.post('/api/service/transfer/trailers', { token: token });
                axios.all([usersPromise, trucksPromise, trailersPromise]).then(axios.spread((users, trucks, trailers) => {
                    this.setState({
                        isLoading: false,
                        did: did,
                        users: users.data.rows,
                        trucks: trucks.data.rows,
                        trailers: trailers.data.rows,
                        driverFrom: lock ? id : null,
                        driverFromLocked: lock,
                    });
                })).catch(error => {
                    addNotification(error.response.data, error.response.status);
                }).finally(function () {
                    removeNotification(u);
                });
            } else {
                var listPromise = axios.post('/api/service/transfer/list', { token: token, did: Number(did) });
                var usersPromise = axios.post('/api/service/transfer/users', { token: token });
                var trucksPromise = axios.post('/api/service/transfer/trucks', { token: token });
                var trailersPromise = axios.post('/api/service/transfer/trailers', { token: token });

                axios.all([listPromise, usersPromise, trucksPromise, trailersPromise]).then(axios.spread((list, users, trucks, trailers) => {
                    this.setState({
                        isLoading: false,
                        did: did,
                        users: users.data.rows, 
                        trucks: trucks.data.rows,
                        trailers: trailers.data.rows,
                        truck: list.data.rows[0].truckNumber,
                        trailer: list.data.rows[0].trailerNumber,
                        mileage: list.data.rows[0].mileage,
                        fuel: list.data.rows[0].fuel,
                        driverFrom: lock ? id : list.data.rows[0].driverFromID,
                        driverFromLocked: lock,
                        driverTo: list.data.rows[0].driverToID,
                    });
                })).catch(error => {
                    addNotification(error.response.data, error.response.status);
                }).finally(function () {
                    removeNotification(u);
                });
            }
        } else {
            if (did == 'new') {
                this.setState({
                    isLoading: false,
                    did: did,
                    users: [
                        { id: 1, name: "Vasia", barcode: "654321" },
                        { id: 2, name: "Petia", barcode: "654322" },
                        { id: 3, name: "Zenia", barcode: "654323" },
                        { id: 4, name: "Vania", barcode: "654324" },
                        { id: 5, name: "John",  barcode: "654325" },
                    ],
                    trucks: [
                        { id: 1, name: "Volvo FH, AA2233AA, 123456", number: "AA2233AA", barcode: "123456" },
                        { id: 2, name: "Scania R, BB2233BB, 123457", number: "BB2233BB", barcode: "123457" },
                        { id: 3, name: "MAN TGX, CC2233CC, 123458",  number: "CC2233CC", barcode: "123458" },
                    ],
                    trailers: [
                        { id: 1, name: "Trailer 1, VV2233VV, 654321", number: "VV2233VV", barcode: "654321" },
                        { id: 2, name: "Trailer 2, WW2233WW, 654322", number: "WW2233WW", barcode: "654322" },
                        { id: 3, name: "Trailer 3, XX2233XX, 654323", number: "XX2233XX", barcode: "654323" },
                    ],
                    driverFrom: lock ? id : null,
                    driverFromLocked: lock,
                });
            } else {
                this.setState({
                    isLoading: false,
                    did: did,
                    users: [
                        { id: 1, name: "Vasia", barcode: "654321" },
                        { id: 2, name: "Petia", barcode: "654322" },
                        { id: 3, name: "Zenia", barcode: "654323" },
                        { id: 4, name: "Vania", barcode: "654324" },
                    ],
                    trucks: [
                        { id: 1, name: "Volvo FH, AA2233AA, 123456", number: "AA2233AA", barcode: "123456" },
                        { id: 2, name: "Scania R, BB2233BB, 123457", number: "BB2233BB", barcode: "123457" },
                        { id: 3, name: "MAN TGX, CC2233CC, 123458",  number: "CC2233CC", barcode: "123458" },
                    ],
                    trailers: [
                        { id: 1, name: "Trailer 1, VV2233VV, 654321", number: "VV2233VV", barcode: "654321" },
                        { id: 2, name: "Trailer 2, WW2233WW, 654322", number: "WW2233WW", barcode: "654322" },
                        { id: 3, name: "Trailer 3, XX2233XX, 654323", number: "XX2233XX", barcode: "654323" },
                    ],
                    truck: "AA2233AA",
                    trailer: "VV2233VV",
                    mileage: "123123",
                    fuel: "50",
                    driverFrom: lock ? id : 1,
                    driverFromLocked: lock,
                    driverTo: 4,
                });
            }
        }
    }

    // Truck
    truckOpen() {
        if (this.state.isTruckOpen) {
            this.setState({isTruckOpen: false, truckSearch: ""});
            return;
        }

        this.setState({isTruckOpen: true});
    }

    renderTrucks() {
        const {lang} = this.context;

        if (this.state.trucks.length === 0) {
            return (
                <div className="row">
                    <div className="col">
                        <div className="card agis-card">
                            <div className="body">
                                <div className="row">
                                    <div className="col" style={{display: "flex", alignItems: "center", height: "30px"}}>
                                        <div>
                                            <h6><b>{localization[lang].noData}</b></h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return this.state.trucks.filter((item, i) => item.name.toLowerCase().includes(this.state.truckSearch.toLowerCase()) || item.number.toLowerCase().includes(this.state.truckSearch.toLowerCase()) || item.barcode.toLowerCase().includes(this.state.truckSearch.toLowerCase())).map((item, i) => {
                return (
                    <div className="row" onClick={() => this.setState({truck: item.number, isTruckOpen: false, truckSearch: ""})} key={i} style={{cursor: "pointer"}}>
                        <div className="col">
                            <div className="card agis-card position-component">
                                <div class="d-flex justify-content-between">
                                    <div className="row">
                                        <div className="col">
                                            <big><b>{item.name}</b></big><br/>
                                            <big>{item.barcode}</big>
                                        </div>
                                    </div>
                                    <div className="align-middle" style={{display: "flex", alignItems: "center"}}>
                                        <span className="mr-1"><FontAwesomeIcon icon={faChevronRight}/></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            });
        }
    }

    // Trailer
    trailerOpen() {
        if (this.state.isTrailerOpen) {
            this.setState({isTrailerOpen: false, trailerSearch: ""});
            return;
        }

        this.setState({isTrailerOpen: true});
    }

    renderTrailers() {
        const {lang} = this.context;

        if (this.state.trailers.length === 0) {
            return (
                <div className="row">
                    <div className="col">
                        <div className="card agis-card">
                            <div className="body">
                                <div className="row">
                                    <div className="col" style={{display: "flex", alignItems: "center", height: "30px"}}>
                                        <div>
                                            <h6><b>{localization[lang].noData}</b></h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return this.state.trailers.filter((item, i) => item.name.toLowerCase().includes(this.state.trailerSearch.toLowerCase()) || item.number.toLowerCase().includes(this.state.trailerSearch.toLowerCase()) || item.barcode.toLowerCase().includes(this.state.trailerSearch.toLowerCase())).map((item, i) => {
                return (
                    <div className="row" onClick={() => this.setState({trailer: item.number, isTrailerOpen: false, trailerSearch: ""})} key={i} style={{cursor: "pointer"}}>
                        <div className="col">
                            <div className="card agis-card position-component">
                                <div class="d-flex justify-content-between">
                                    <div className="row">
                                        <div className="col">
                                            <big><b>{item.name}</b></big><br/>
                                            <big>{item.barcode}</big>
                                        </div>
                                    </div>
                                    <div className="align-middle" style={{display: "flex", alignItems: "center"}}>
                                        <span className="mr-1"><FontAwesomeIcon icon={faChevronRight}/></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            });
        }
    }

    // Driver From
    driverFromOpen() {
        if (this.state.isDriverFromOpen) {
            this.setState({isDriverFromOpen: false, driverFromSearch: ""});
            return;
        }

        this.setState({isDriverFromOpen: true});
    }

    renderDriverFrom() {
        const {lang} = this.context;

        if (this.state.users.length === 0) {
            return (
                <div className="row">
                    <div className="col">
                        <div className="card agis-card">
                            <div className="body">
                                <div className="row">
                                    <div className="col" style={{display: "flex", alignItems: "center", height: "30px"}}>
                                        <div>
                                            <h6><b>{localization[lang].noData}</b></h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return this.state.users.filter((item, i) => item.name.toLowerCase().includes(this.state.driverFromSearch.toLowerCase()) || item.barcode.toLowerCase().includes(this.state.driverFromSearch.toLowerCase())).map((item, i) => {
                return (
                    <div className="row" onClick={() => this.setState({driverFrom: item.id, isDriverFromOpen: false, driverFromSearch: ""})} key={i} style={{cursor: "pointer"}}>
                        <div className="col">
                            <div className="card agis-card position-component">
                                <div class="d-flex justify-content-between">
                                    <div className="row">
                                        <div className="col">
                                            <big><b>{item.name}</b></big><br/>
                                            <big>{item.barcode}</big>
                                        </div>
                                    </div>
                                    <div className="align-middle" style={{display: "flex", alignItems: "center"}}>
                                        <span className="mr-1"><FontAwesomeIcon icon={faChevronRight}/></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            });
        }
    }

    // Driver To
    driverToOpen() {
        if (this.state.isDriverToOpen) {
            this.setState({isDriverToOpen: false, driverToSearch: ""});
            return;
        }

        this.setState({isDriverToOpen: true});
    }

    renderDriverTo() {
        const {lang} = this.context;

        if (this.state.users.length === 0) {
            return (
                <div className="row">
                    <div className="col">
                        <div className="card agis-card">
                            <div className="body">
                                <div className="row">
                                    <div className="col" style={{display: "flex", alignItems: "center", height: "30px"}}>
                                        <div>
                                            <h6><b>{localization[lang].noData}</b></h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return this.state.users.filter((item, i) => item.name.toLowerCase().includes(this.state.driverToSearch.toLowerCase()) || item.barcode.toLowerCase().includes(this.state.driverToSearch.toLowerCase())).map((item, i) => {
                return (
                    <div className="row" onClick={() => this.setState({driverTo: item.id, isDriverToOpen: false, driverToSearch: ""})} key={i} style={{cursor: "pointer"}}>
                        <div className="col">
                            <div className="card agis-card position-component">
                                <div class="d-flex justify-content-between">
                                    <div className="row">
                                        <div className="col">
                                            <big><b>{item.name}</b></big><br/>
                                            <big>{item.barcode}</big>
                                        </div>
                                    </div>
                                    <div className="align-middle" style={{display: "flex", alignItems: "center"}}>
                                        <span className="mr-1"><FontAwesomeIcon icon={faChevronRight}/></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            });
        }
    }

    // Input change
    onInputChange(e, field) {
        switch (field) {
            case "truck":
                this.setState({truck: e.target.value});
                break
            case "trailer":
                this.setState({trailer: e.target.value});
                break
            case "mileage":
                this.setState({mileage: e.target.value});
                break
            case "fuel":
                this.setState({fuel: e.target.value});
                break
            case "driverFrom":
                this.setState({driverFrom: Number(e.target.value)});
                break
            case "driverTo":
                this.setState({driverTo: Number(e.target.value)});
                break
        }
    }

    // Save
    save() {
        const {addNotification, removeNotification, token, lang} = this.context;

        var u = addNotification("Завантаження...");
        axios.post('/api/service/transfer/save', { 
            token: token, 
            did: this.state.did == 'new' ? 0 : Number(this.state.did),
            truck: this.state.truck,
            trailer: this.state.trailer,
            mileage: this.state.mileage,
            fuel: this.state.fuel,
            driverFrom: this.state.driverFrom,
            driverTo: this.state.driverTo,
        }).then((res) => {
            if (res.data.serror == "") {
                this.setState({redirect: "/service/transfer/"});
            } else {
                addNotification(res.data.serror, 2);
            }
        }).catch((error) => {
            addNotification(error.response.data, error.response.status);
        }).finally(function () {
            removeNotification(u);
        });
    }

    render() {
        const {lang} = this.context;

        if (this.state.redirect !== null) {
            return <Redirect to={this.state.redirect} />
        }

        const meta = {
			title: localization[lang].title,
			description: localization[lang].title,
			meta: {
			  	charset: 'utf-8'
			}
        };

        if (this.state.isLoading) {
            return (
                <div>Loading...</div>
            );
        }

        return (
            <div>
                <DocumentMeta {...meta} />
                <OffsetTop submenu={false} />

                {this.state.isTruckOpen && (
                    <div className="fixed-bottom" onClick={this.truckOpen} style={{zIndex: 2000, height: "100%", backgroundColor: "#80808094"}}>
                        <div className="fixed-bottom" onClick={(e) => {e.stopPropagation()}} style={{height: "85%", borderTopLeftRadius: "30px", borderTopRightRadius: "30px", backgroundColor: "#fff", overflowX: "auto"}}>
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-md-10 offset-md-1">
                                        <div className="container-fluid pl-0 pr-0">
                                            <br/>
                                            <div className="row mb-4">
                                                <div className="col d-flex align-items-center">
                                                    <h5 className="text-muted" style={{lineHeight: "40px"}}>{localization[lang].chooseTruck}</h5>
                                                </div>
                                            </div>
                                            <input type="text" className="question-input" style={{height: "40px", width: "100%", fontSize: "16px", borderRadius: "10px", backgroundColor: "#fff"}} placeholder={localization[lang].searchText} value={this.state.truckSearch} onChange={(e) => this.setState({truckSearch: e.target.value})} autoFocus={true} />
                                            <br/><br/>
                                            {this.renderTrucks()}
                                            <br/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {this.state.isTrailerOpen && (
                    <div className="fixed-bottom" onClick={this.trailerOpen} style={{zIndex: 2000, height: "100%", backgroundColor: "#80808094"}}>
                        <div className="fixed-bottom" onClick={(e) => {e.stopPropagation()}} style={{height: "85%", borderTopLeftRadius: "30px", borderTopRightRadius: "30px", backgroundColor: "#fff", overflowX: "auto"}}>
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-md-10 offset-md-1">
                                        <div className="container-fluid pl-0 pr-0">
                                            <br/>
                                            <div className="row mb-4">
                                                <div className="col d-flex align-items-center">
                                                    <h5 className="text-muted" style={{lineHeight: "40px"}}>{localization[lang].chooseTrailer}</h5>
                                                </div>
                                            </div>
                                            <input type="text" className="question-input" style={{height: "40px", width: "100%", fontSize: "16px", borderRadius: "10px", backgroundColor: "#fff"}} placeholder={localization[lang].searchText} value={this.state.trailerSearch} onChange={(e) => this.setState({trailerSearch: e.target.value})} autoFocus={true} />
                                            <br/><br/>
                                            {this.renderTrailers()}
                                            <br/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {this.state.isDriverFromOpen && (
                    <div className="fixed-bottom" onClick={this.driverFromOpen} style={{zIndex: 2000, height: "100%", backgroundColor: "#80808094"}}>
                        <div className="fixed-bottom" onClick={(e) => {e.stopPropagation()}} style={{height: "85%", borderTopLeftRadius: "30px", borderTopRightRadius: "30px", backgroundColor: "#fff", overflowX: "auto"}}>
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-md-10 offset-md-1">
                                        <div className="container-fluid pl-0 pr-0">
                                            <br/>
                                            <div className="row mb-4">
                                                <div className="col d-flex align-items-center">
                                                    <h5 className="text-muted" style={{lineHeight: "40px"}}>{localization[lang].chooseDriverFrom}</h5>
                                                </div>
                                            </div>
                                            <input type="text" className="question-input" style={{height: "40px", width: "100%", fontSize: "16px", borderRadius: "10px", backgroundColor: "#fff"}} placeholder={localization[lang].searchText} value={this.state.driverFromSearch} onChange={(e) => this.setState({driverFromSearch: e.target.value})} autoFocus={true} />
                                            <br/><br/>
                                            {this.renderDriverFrom()}
                                            <br/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {this.state.isDriverToOpen && (
                    <div className="fixed-bottom" onClick={this.driverToOpen} style={{zIndex: 2000, height: "100%", backgroundColor: "#80808094"}}>
                        <div className="fixed-bottom" onClick={(e) => {e.stopPropagation()}} style={{height: "85%", borderTopLeftRadius: "30px", borderTopRightRadius: "30px", backgroundColor: "#fff", overflowX: "auto"}}>
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-md-10 offset-md-1">
                                        <div className="container-fluid pl-0 pr-0">
                                            <br/>
                                            <div className="row mb-4">
                                                <div className="col d-flex align-items-center">
                                                    <h5 className="text-muted" style={{lineHeight: "40px"}}>{localization[lang].chooseDriverTo}</h5>
                                                </div>
                                            </div>
                                            <input type="text" className="question-input" style={{height: "40px", width: "100%", fontSize: "16px", borderRadius: "10px", backgroundColor: "#fff"}} placeholder={localization[lang].searchText} value={this.state.driverToSearch} onChange={(e) => this.setState({driverToSearch: e.target.value})} autoFocus={true} />
                                            <br/><br/>
                                            {this.renderDriverTo()}
                                            <br/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-10 offset-md-1">

                            <div className="card agis-card pt-1 pb-1 mt-3" style={{backgroundColor: '#f1f3f4'}}>
                                <div className="row">
                                    <div className="col" style={{display: "flex", alignItems: "center", height: "30px"}}>
                                        <div>
                                            <h6><b>{this.state.did == 'new' ? localization[lang].new : localization[lang].edit}</b></h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card agis-card">
                                <div className="row">
                                    <div className="col">
                                        <span>{localization[lang].truck}</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col d-flex justify-content-between">
                                        <input type="text" autoComplete="new-password" className="agis-input" onFocus={this.truckOpen} value={this.state.truck} />
                                    </div>
                                </div>
                            </div>
                            <div className="card agis-card">
                                <div className="row">
                                    <div className="col">
                                        <span>{localization[lang].trailer}</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col d-flex justify-content-between">
                                        <input type="text" autoComplete="new-password" className="agis-input" onFocus={this.trailerOpen} value={this.state.trailer} />
                                    </div>
                                </div>
                            </div>
                            <div className="card agis-card">
                                <div className="row">
                                    <div className="col">
                                        <span>{localization[lang].mileage}</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col d-flex justify-content-between">
                                        <input type="text" autoComplete="new-password" className="agis-input" onChange={(e) => this.onInputChange(e, "mileage")} value={this.state.mileage} />
                                    </div>
                                </div>
                            </div>
                            <div className="card agis-card">
                                <div className="row">
                                    <div className="col">
                                        <span>{localization[lang].fuel}</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col d-flex justify-content-between">
                                        <input type="text" autoComplete="new-password" className="agis-input" onChange={(e) => this.onInputChange(e, "fuel")} value={this.state.fuel} />
                                    </div>
                                </div>
                            </div>
                            <div className="card agis-card">
                                <div className="row">
                                    <div className="col">
                                        <span>{localization[lang].driverFrom}</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col d-flex justify-content-between">
                                        <input type="text" autoComplete="new-password" className="agis-input" style={{backgroundColor: this.state.driverFromLocked ? "#eeeeee" : "white"}} onFocus={this.driverFromOpen} value={this.state.driverFrom ? this.state.users.find(user => user.id === this.state.driverFrom)?.name : ""} disabled={this.state.driverFromLocked} />
                                    </div>
                                </div>
                            </div>
                            <div className="card agis-card">
                                <div className="row">
                                    <div className="col">
                                        <span>{localization[lang].driverTo}</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col d-flex justify-content-between">
                                        <input type="text" autoComplete="new-password" className="agis-input" onFocus={this.driverToOpen} value={this.state.driverTo ? this.state.users.find(user => user.id === this.state.driverTo)?.name : ""} />
                                    </div>
                                </div>
                            </div>

                            <button className="btn-agis-primary mt-3 w-100" onClick={this.save}>{localization[lang].button}</button>

                            <br/>
                            <br/>

                            <button className="btn-agis-light-outline" onClick={() => this.setState({redirect: '/service/transfer'})} style={{height: "30px", width: '100%', minWidth: "0px", border: "1px solid #ebebeb"}}>Назад до списку</button>

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default CheckListNew;